import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import { QuitEditingModal } from 'src/components/shared/quit-editing-modal/quit-editing-modal';
import { MainPages, ProtectionMenuNameOptions } from '@src/utils/enums';
import { usePageViewEvent } from '../../shared/hooks/use-page-view-event';
import { useStores } from '../../store';
import './ip-control.scss';

export const IPControl: React.FC = observer(() => {
    const { fwVersionStore, unsavedChangesStore } = useStores();

    usePageViewEvent(MainPages.POLICY, ProtectionMenuNameOptions.IP_CONTROL);

    useEffect(() => {
        fwVersionStore.setProtectionType(ProtectionMenuNameOptions.IP_CONTROL);
    }, []);

    useEffect(() => {
        // the handler for actually showing the prompt
        const handler = (event: BeforeUnloadEvent) => {
            if (unsavedChangesStore.hasUnsavedChanges) {
                event.preventDefault();
            }
        };

        window.addEventListener('beforeunload', handler);
        // clean it up, if the dirty state changes
        return () => unsavedChangesStore.deleteAllUnsavedChanges();
    }, []);

    return <div className="ip-control" data-testid="ip-control">
        <div className="page-content" data-testid="page-content">
            <ReactRouterPrompt when={unsavedChangesStore.hasUnsavedChanges}>
                {({ isActive, onConfirm: onDiscaredChnages, onCancel: onStayEdit }) =>
                    isActive && <QuitEditingModal onDiscaredChanges={onDiscaredChnages} onStayEdit={onStayEdit}/>
                }
            </ReactRouterPrompt>
            <Outlet/>
        </div>
    </div>;
});
